import React, { Component } from 'react'
import { Button } from 'reactstrap';
import '../App.css';
import LoggedContext from '../BusinessObjects/LoggedContext'


interface IEsaedroJumpMenuProps {
  name:string;
  className:string;
  onClick?(menuItemId: any): void;
  items: any[]
}

export default class EsaedroJumpMenu extends Component<IEsaedroJumpMenuProps> {
  
  constructor(props: IEsaedroJumpMenuProps){
      super(props);

  }

  jumpMenuItemSelected = (e: any) => {
    if (this.props.onClick!=undefined) {
      this.props.onClick(e.target.value)
    }
  }

  render() {

    if (this.props.items.length) {
      const elements = (this.props.items!==undefined? this.props.items.map((menuVoice: any) => {
        return (
          <span><Button outline color="primary" value={menuVoice.JumpName} onClick={this.jumpMenuItemSelected}> <i className="fa fa-search"></i> {menuVoice.JumpLabel} </Button>     </span>
        )
      }
      ):'Errore: non ci sono elementi da visualizzare...');

      return (
        <div className={this.props.className?this.props.className:"form-group"}>
          {elements}   
        </div>
      )
    }
    else return (
      <div className={this.props.className?this.props.className:"form-group"}>
      </div>
    )
  }
}
  